// RÉGI CÍM → ÁTIRÁNYÍTÁS. A hozzárendelés-lista a `/services` lap „Szolgáltatások" füle lett; ez a route
// CSAK a korábbi linkeket tartja életben.
//
// MIÉRT KELL: erre a címre mutat az értesítés-harang mélylinkje (`ref-to-route.ts`, `kind=service-assignment`
// → `?highlight=`), az ügyfél-detail „Összes megtekintése" belépője (`?clientId=`), a generálási
// kihagyás-napló sor-akciója és a ⌘K-paletta szerkesztés-ugrása (`?edit=`) — plusz a felhasználók könyvjelzői
// és a doksik. Egy törölt route mindezeket 404-re vinné, MIÉG a régi értesítések is a régi alakot hordozzák
// (azok már kimentek, visszamenőleg nem írhatók át).
//
// A SEARCH-PARAMOK IS ÁTFORDULNAK: a `/services` lapon két lista ül, ezért ott minden szűrő prefixes
// (`asg_`) — a régi, prefix nélküli alakot itt képezzük le, hogy a linkelt NÉZET is megmaradjon, ne csak a lap.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { assignmentsRedirectSearch } from '@/features/services/legacy-redirect';

/** A RÉGI kulcs-készlet (változatlanul) — ezt fordítjuk `asg_*`-ra. */
const legacySearchSchema = z.object({
  edit: z.string().optional(),
  clientId: z.string().optional(),
  highlight: z.string().optional(),
  q: z.string().optional(),
  account: z.string().optional(),
  scope: z.string().optional(),
  type: z.string().optional(),
  status: z.string().optional(),
  frequency: z.string().optional(),
  agreement: z.string().optional(),
  pricing: z.string().optional(),
  sort: z.string().optional(),
  order: z.string().optional(),
});

export const Route = createFileRoute('/service-assignments')({
  validateSearch: (search) => legacySearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/services', replace: true, search: assignmentsRedirectSearch(search) });
  },
});
